export type FilePreviewKind = 'image' | 'pdf' | 'video' | 'other';

const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'gif'];
const VIDEO_EXTENSIONS = ['mp4', 'webm', 'mov', 'quicktime'];

function resolveFileExtension(filename: string): string {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return '';
  }
  return filename.slice(lastDotIndex + 1).toLowerCase();
}

export function resolveFilePreviewKind(
  contentType: string | null,
  filename: string | null
): FilePreviewKind {
  if (contentType !== null) {
    if (contentType.startsWith('image/')) {
      return 'image';
    }
    if (contentType === 'application/pdf') {
      return 'pdf';
    }
    if (contentType.startsWith('video/')) {
      return 'video';
    }
  }

  if (filename !== null) {
    const extension = resolveFileExtension(filename);
    if (IMAGE_EXTENSIONS.includes(extension)) {
      return 'image';
    }
    if (extension === 'pdf') {
      return 'pdf';
    }
    if (VIDEO_EXTENSIONS.includes(extension)) {
      return 'video';
    }
  }

  return 'other';
}
